import { Select as OriginSelect } from '@material-ui/core';
import React from 'react';
import { loginChecker } from '../../utils/login-controler';
import { useHistory } from 'react-router';

/**
 * click時にアクセス権限のチェックを行う
 * @param props
 */
export const Select: React.FC<any> = (props: any) => {
  const history = useHistory();

  const { onChange, ...otherProps } = props;
  const onChangeWithAuthCheck = (e: any) => {
    if (loginChecker(history)) {
      return;
    }

    onChange(e);
  };

  return (
    <OriginSelect {...otherProps} onChange={e => onChangeWithAuthCheck(e)} />
  );
};

export default Select;
